import React, {useEffect, useState} from "react";
import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, IconButton, Typography} from "@material-tailwind/react";
import {LoaderEllipsisComponent} from "../../../components/elements/Loader/LoaderComponent"
import {CircleStackIcon, ArrowDownIcon, CubeIcon, ScaleIcon} from "@heroicons/react/24/outline";
import { XMarkIcon} from "@heroicons/react/24/solid";
import { setMoney} from "../../../utils/shared";
import api from "../../../js/api";
import {toastError, toastInfo} from '../../../js/toast';

function ModalDividir({handler, open, itemProd, research}) {
  const [loaderLocal, setLoaderLocal] = useState(false);
  
  const confirmarDivicion = () => {
    setLoaderLocal(true)
    
    api.post('product-presentation/dividir', {...itemProd, add_quantity: cantidadLibras(itemProd)})
        .then((res) => {
          const name = itemProd.name.replace(/\s*\([^)]*\)/g, '');
          const e = {target: {value: name}}
          research(e, true);
          toastInfo("Producto dividido con exito")
          handler()

        })
        .catch((err) => {
          console.log('err', err);
          if(err?.response?.data?.details) {
            toastError(err?.response?.data?.details)
          } else {
            toastError('No se pudo dividir')
          }
        })
        .finally(() => {
          setLoaderLocal(false);
        })
  }

  return (
    <>
      <Dialog
        size="md"
        className=""
        open={open}
        handler={handler}
        dismiss={{outsidePress: false}}
      >
        <LoaderEllipsisComponent loader={loaderLocal}/>

        <DialogHeader>
          <Typography variant="h4" className="mx-auto font-semibold pb-0 pt-4">Dividir producto</Typography>
          <IconButton className="border" onClick={handler}>
            <XMarkIcon className="text-black w-4 h-4"/>
          </IconButton>
        </DialogHeader>
        <DialogBody className="h-full overflow-y-auto max-h-[650px] py-0">
          {itemProd?.id ? 
          <div className="card flex flex-col align-middle  m-1 rounded-md px-4  gap-y-1 mx-auto w-[290px]">
            <div className="border p-3">
             <div className="flex flex-row gap-y-2 gap-x-1.5">
               <CubeIcon className="w-5 h-5 text-black font-bold"/>
               <Typography className="" variant="small" color="black">
                 {itemProd.name}
               </Typography>
             </div>
            <div className="flex flex-row gap-y-2 gap-x-1.5">
              <CircleStackIcon className="w-5 h-5 text-black"/>
              <Typography  variant="small" className='text-right lg:md:2xl:xl:justify-end'>
                {setMoney(itemProd?.prices[0]?.amount * 1)}
              </Typography>
             </div>
            </div>

            <div className="">
              <div className="flex flex-row gap-y-2 justify-center gap-x-1.5">
               <ArrowDownIcon className="w-5 h-5 text-black"/>
              </div>
              <div className="flex flex-row gap-y-2 justify-center gap-x-1.5">
                <Typography className="text-[12px]" variant="small" color="black">
                  Se sumaran al inventario <span className="font-bold">{cantidadLibras(itemProd)} unidades </span>
                  de:
                </Typography>
              </div>
              <div className="flex flex-row gap-y-2 justify-center gap-x-1.5">
               <ArrowDownIcon className="w-5 h-5 text-black"/>
              </div>
            </div>

            <div className="border p-3">
              <div className="flex flex-row gap-y-2 gap-x-1.5">
                <CubeIcon className="w-5 h-5 text-black"/>
                <Typography className="" variant="small" color="black">
                  {itemProd.name.replace(/\s*\([^)]*\)/g, '')} (Libreado 1lb).
                </Typography>
              </div>
            </div>

          </div> :
          <div className="flex">Sin datos</div>
          }
        </DialogBody>
        <DialogFooter className="mx-auto w-full !justify-center mb-4">

            <Button type="button" className="mt-3" onClick={confirmarDivicion}>
                  Confirmar
            </Button>
        
        </DialogFooter>
      </Dialog>

    </>
  );
}


export function XIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 6 6 18"/>
      <path d="m6 6 12 12"/>
    </svg>
  )
}


function cantidadLibras(pp) {
  let texto = pp?.name ?? ""
  let medida  = texto.match(/\(([^)]+)\)/)[1];
  var regexDigitos = /(\d+)/g;
  let medidaNumero = medida.match(regexDigitos) ? medida.match(regexDigitos)[0] : 100;
  return medidaNumero
}

export default ModalDividir